"use strict";

class DataLayer {
  constructor(data = {}) {
    this.data = data;

    this.selectors = {
      headerMenuLinks: ".full-mega-menu a",
      newsletterForm: ".newsletter-form",
      socialLinks: ".social-links .social",
    };

    this.buttonsSelectors = [
      'button',
      '.text-button',
      '.back-to-top',
      '[role="button"]',
      'input[type="button"]',
      'input[type="submit"]',
      '.mobile-filters-clear'
    ];

    this.skipButtonSelectors = [
      '.wishlist-button',
      '#AddToCart',
      '.cart-update button',
      '.klaviyo-form button',
      '.main-slideshow .button',
      '.promotional-banner .button',
      '.product-slider--image-text .button',
      '.gallery-row .button',
      '.section-image-with-text-slideshow .button',
      'collection-tabs button'
    ];

    this.dataLayer = window.dataLayer || [];
    this.headerMenuLinks = document.querySelectorAll(this.selectors.headerMenuLinks);

    if (!Object.keys(data).length) return;
    this.initData(this.data);

    this.newsletterForm();
    this.bannersClick();
    this.eventListeners();

    this.generalButtonsClick();
    this.allPopUpsHandler();
    this.collapsibleHandler();
    this.errorEventHandler()
    this.socialIcons();

    this.contactFormHandler();

    this.dataLayerErrorHandler();
  }

  initData(data) {
    if (data.site) {
      data.site.mediaquery = this.getCurrentBreakpoint();
    }
    if (data.page) {
      this.page = data.page;
    }

    this.resetEcommerce();
    this.dataLayer.push(this.data);
  }

  eventListeners() {
    this.headerMenuLinks.forEach((link) => {
      link?.addEventListener("click", (e) => this.handleNavigationUse(e));
    });
  }

  resetEcommerce() {
    this.dataLayer.push({ecommerce: null});
  }

  getCurrentBreakpoint() {
    const width = window.innerWidth;
    return width <= 600 ? "small" : width <= 960 ? "medium" : "large";
  }

  handleNavigationUse(event) {
    const link = event.currentTarget;

    if (!link.closest(".full-mega-menu")) return;

    let navigationLevel = 0;
    const parentPanel = link.closest(".full-mega-menu--subpanel");
    const parentName = parentPanel?.dataset?.parent || "";
    let navigationText = link.textContent.trim();

    if (link.classList.contains("full-mega-menu--link-parent")) {
      navigationLevel = 1;
    } else if (link.classList.contains("menu-link-level-1")) {
      navigationLevel = 2;
      if (parentName) navigationText = parentName + " | " + navigationText;
    } else if (link.classList.contains("menu-link-level-2")) {
      navigationLevel = 3;
      let level1Text = "";
      const level1Link = link
        .closest(".mega-menu-panel--list")
        ?.querySelector(".menu-link-level-1");
      if (level1Link) level1Text = level1Link.textContent.trim();
      navigationText = [parentName, level1Text, navigationText]
        .filter(Boolean)
        .join(" | ");
    }

    this.resetEcommerce();
    this.dataLayer.push({
      event: "navigation_use",
      navigation_text: navigationText,
      navigation_level: navigationLevel,
    });
  }

  newsletterForm() {
    const timeout = 5000;
    const intervalTime = 500;
    const maxAttempts = Math.ceil(timeout / intervalTime);
    let attempts = 0;

    const intervalId = setInterval(() => {
      attempts++;
      const form = document.querySelector("[class^='klaviyo-form-'] form");
      if (form) {
        if (!form) return;
        clearInterval(intervalId);
        this.attachNewsletterButtonSubmit(form);
        this.attachNewsletterSubmit(form);
      } else if (attempts >= maxAttempts) {
        clearInterval(intervalId);
        console.warn("Klaviyo form not found");
      }
    }, intervalTime);
  }

  attachNewsletterButtonSubmit(form) {
    const buttons = form.querySelectorAll('button[type="button"]');

    buttons.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();

        form.requestSubmit();
      });
    });
  }

  attachNewsletterSubmit(form) {
    form.addEventListener("submit", (event) => {
      const emailInput = form.querySelector('input[type="email"]');
      const emailValue = emailInput ? emailInput.value : "";
      const formId = form.parentElement.classList[0] || "Unknown_form";

      this.resetEcommerce();
      this.dataLayer.push({
        event: "newsletter_subscription",
        email: emailValue,
        formId,
      });
    });
  }

  bannersClick() {
    if (this.page !== "homepage") return;

    const bannerSelectors = [
      ".main-slideshow a",
      ".promotional-banner a",
      ".product-slider--image-text a",
      ".gallery-row a",
      ".section-image-with-text-slideshow a",
    ];

    const bannerLinks = document.querySelectorAll(bannerSelectors.join(","));

    bannerLinks.forEach((bannerLink) => {
      bannerLink.addEventListener("click", (e) => {
        const bannerLinkHref = bannerLink.getAttribute("href");

        const bannerLinkValue =
          bannerLinkHref?.split("/").filter(Boolean).join(" | ") || "";

        this.resetEcommerce();
        this.dataLayer.push({
          event: "banner_click",
          navigation_text: bannerLinkValue,
        });
      });
    });
  }

  generalButtonsClick() {
    document.addEventListener("click", (e) => {
      const el = e.target.closest(this.buttonsSelectors);
      if (!el || el.closest(this.skipButtonSelectors)) return;

      if(el.dataset?.layerPopupCta) {
        this.setDataLayerPopUp('popup_cta', el.dataset.layerPopupCta);
      }

      this.dataLayer.push({
        event: "button_click",
        navigation_text: this.getElText(el),
      });
    })
  }

  allPopUpsHandler() {
    document.addEventListener("quick-view:open", (e) => {
      const { popUp } = e?.detail
      markButtons(popUp);
      this.setDataLayerPopUp('popup_visible', popUp.id)
    });

    document.addEventListener("modal-dialog:open", (e) => {
      const { popUp } = e?.detail
      markButtons(popUp);
      this.setDataLayerPopUp('popup_visible', popUp.id)
    });

    document.addEventListener("modal-dialog:close", (e) => {
      const { popUpId } = e?.detail;
      this.setDataLayerPopUp('popup_close', popUpId)
    });

    document.addEventListener("panel-custom:close", (e) => {
      const { popUpId } = e?.detail;
      this.setDataLayerPopUp('popup_close', popUpId)
    });

    const isVisualPopUp = (popUp) => {
      if (!popUp) return false;
      const cs = window.getComputedStyle(popUp);
      return cs.display !== 'none' && cs.visibility !== 'hidden';
    }

    const getIdPopUp = (popUp) => {
      return popUp.id ||
        popUp.closest('[id]')?.id ||
        popUp.querySelector('form[data-id]')?.dataset.id ||
        popUp.querySelector('form[data-testid]')?.dataset.testid ||
        popUp.getAttribute('class') ||
        'unknown_popup';
    }

    // Restock alerts popup
    this.observerHandler('.restock-alerts-modal-box').then(el => {
      if(isVisualPopUp(el)) {
        markButtons(el);
        const id = getIdPopUp(el);
        this.setDataLayerPopUp('popup_visible', id)
      }
    });

    // Cookie popups
    this.observerHandler('#shopify-pc__banner').then(el => {
      if(isVisualPopUp(el)) {
        markButtons(el);
        const id = getIdPopUp(el);
        this.setDataLayerPopUp('popup_visible', id)
      }
    });

    // Cartbot popup
    this.observerHandler('.cartbot-confirmation-modal').then(el => {
      if(isVisualPopUp(el)) {
        markButtons(el);
        const id = getIdPopUp(el);
        this.setDataLayerPopUp('popup_visible', id)
      }
    });

    // Klaviyo popups
    this.observerHandler('[role="dialog"][class*="kl-private"]', {
      onChange: (el) => {
        if(isVisualPopUp(el)) {
          markButtons(el);
          const id = getIdPopUp(el);
          this.setDataLayerPopUp('popup_visible', id)
        }
      }
    });

    const markButtons = (popUp) => {
      const selectors = this.buttonsSelectors.map(sel => {
        return `${sel}:not([class*="modal__toggle"])`;
      });

      popUp.querySelectorAll(selectors).forEach(el => {
        el.dataset.layerPopupCta = popUp.id;
      })
    }
  }

  observerHandler(selector, { root = document, onChange } = {}) {

    let visitedEl = false;

    return new Promise((resolve) => {
      let resolved = false;
      let predicate = null;

      if(selector instanceof Node) {
        predicate = () => selector;
      } else {
        predicate = () => root.querySelector(selector);
      }

      const startAttrWatch = (el) => {
        const attrObserver = new MutationObserver(mutations => {
          if (typeof onChange === 'function' && !visitedEl) {
            onChange(el);
            visitedEl = true;
          }
        });

        attrObserver.observe(el, {
          attributes: true,
          attributeFilter: ['class','style','hidden','aria-hidden']
        });

        return () => { try { attrObserver.disconnect(); } catch {} };
      }

      const finish = (el) => {
        if (resolved) return;
        resolved = true;
        try { domObserver.disconnect(); } catch {}
        startAttrWatch(el);
        resolve(el);
      };

      const immediate = predicate();
      if (immediate) return finish(immediate);

      const domObserver = new MutationObserver(() => {
        const el = predicate();
        if (el) finish(el);
      });

      domObserver.observe(root, { childList: true, subtree: true });
    });
  }

  getElText = (el) => {
    return this.trimText(el) ||
    el.dataset.navText ||
    el.getAttribute('aria-label') ||
    el.getAttribute('title') ||
    el.querySelector('[data-content]')?.dataset.content ||
    el.getAttribute('class') ||
    this.trimText(el.parentNode)
  }

  trimText = (el) => {
    return (el?.textContent || '').replace(/\s+/g, ' ').trim()
  }

  setDataLayerPopUp = (eventType, id) => {
    id && this.dataLayer.push({
      event: eventType,
      popup_id: id
    })
  }

  setDataLayerErrorMessage = (text, field) => {
    this.dataLayer.push({
      event: 'validation_message',
      validation_text: text,
      validation_field: field
    })
  }

  collapsibleHandler = () => {
    document.addEventListener("collapsible-row:close", (e) => {
      const { el } = e?.detail

      this.dataLayer.push({
        event: 'collapsible_close',
        navigation_text: this.getElText(el)
      })
    });

    document.addEventListener("collapsible-row:open", (e) => {
      const { el } = e?.detail

      this.dataLayer.push({
        event: 'collapsible_open',
        navigation_text: this.getElText(el)
      })
    });
  }

  errorEventHandler() {
    document.addEventListener("gtm:error", (e) => {
      const { error } = e?.detail

      this.dataLayer.push({
        event: 'text_message',
        message_text: error || 'Error occurred'
      })
    });
  }

  socialIcons() {
    const socialLinks = document.querySelectorAll(
      this.selectors.socialLinks,
    );

    socialLinks.forEach((link) => {
      let href = link.href;

      if (!href) return;

      link.addEventListener("click", () => {
        this.dataLayer.push({
          event: "contact",
          platform: this.extractPlatformName(href),
        });
      });
    });
  }

  contactFormHandler() {
    const form = document.querySelector('form[action*="/contact"]');
    if (!form) return;

    form.querySelector('[type="submit"]').addEventListener('click', e => {
      form.querySelectorAll('input:invalid, textarea:invalid').forEach(invalidEl => {
        const validity = invalidEl?.validity;
        if(validity.valueMissing) {
          const text = 'Please fill out this field.';
          const field = invalidEl.type;

          this.setDataLayerErrorMessage(text, field)
        }

        if(validity.typeMismatch) {
          const text = 'please include an "@" in the email address. "test" is missing an "@".';
          const field = invalidEl.type;

          this.setDataLayerErrorMessage(text, field)
        }
      })
    })

    form.addEventListener('submit', e => {
      this.dataLayer.push({
        event: "contact",
        platform: "contact_form_submit",
      })
    })
  }

  dataLayerErrorHandler() {
    this.observerHandler('.footer-klaviyo .klaviyo-form [type="email"][aria-invalid="true"]').then(el => {
      pushErrorEmail(el);
    });

    this.observerHandler('.footer-klaviyo .klaviyo-form [type="checkbox"][aria-invalid="true"]').then(el => {
      pushErrorCheckbox(el);
    });

    this.observerHandler('[role="dialog"] .klaviyo-form [type="email"][aria-invalid="true"]').then(el => {
      pushErrorEmail(el);
    });

    this.observerHandler('[role="dialog"] .klaviyo-form [type="checkbox"][aria-invalid="true"]').then(el => {
      pushErrorCheckbox(el);
    });

    const pushErrorEmail = (el) => {
      const text = this.trimText(el.parentNode?.querySelector('[role="alert"]'));
      const field = 'klaviyo email';

      this.setDataLayerErrorMessage(text, field)
    }

    const pushErrorCheckbox = (el) => {
      const text = this.trimText(el.parentNode.parentNode.querySelector('[role="alert"]'));
      const field = 'klaviyo checkbox';

      this.setDataLayerErrorMessage(text, field)
    }

    // Restock alerts
    this.observerHandler('.restock-alerts-modal-box [class*="errorStyle"]').then(el => {
      const text = this.trimText(el);
      const field = 'Email address';

      this.setDataLayerErrorMessage(text, field)
    });
  }

  extractPlatformName(url) {
    try {
      const parsedUrl = new URL(url);
      const hostname = parsedUrl.hostname;
      const parts = hostname.split(".");

      return parts.length > 2 ? parts[parts.length - 2] : parts[0];
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  }
}
